import React, { useState, useEffect } from "react";
import { Transition } from "react-transition-group";
import { navigate } from "gatsby";
import Lottie from "react-lottie";
import cx from "clsx";
import { isSafari, isTablet } from "react-device-detect";

import Button from "@/components/shared/button";
import Dimmer from "@/components/shared/dimmer";
import HandSvg from "@/images/tour/hand.svg";

import vars from "@/styles/_variables.scss";
import tourStyles from "@/components/tour/tour.module.scss";
import globalStyles from "@/styles/global.module.scss";
import styles from "./tourOutro.module.scss";

const LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: require("@/assets/lottie/mouse-icon.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const TourOutro = props => {
  const {
    visible,
    isCovered,
    links,
    isDesktop,
    windowHeight,
    safariHeight
  } = props;

  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    if (!hasMounted) setHasMounted(true);
  }, []); // eslint-disable-line

  const handleButtonClick = (item, props) => () => {
    const { onFilmClick } = props;

    if (item && item.link) {
      if (item.link === "/film") onFilmClick && onFilmClick();
      else navigate(item.link, { state: { fromNavbar: false }, replace: true });
    }
  };

  if (!visible) return null;

  let height = isDesktop
    ? windowHeight
    : (isSafari ? safariHeight : windowHeight) -
      parseInt(vars.navbarMobileHeight) -
      parseInt(vars.tourBottomHeight);

  if (!hasMounted) height = 0;

  return (
    <Transition in={hasMounted && visible} timeout={0}>
      {state => {
        return (
          <>
            <div
              className={cx(
                styles.buttons,
                isCovered && styles.isCovered,
                isDesktop && styles.isDesktop,
                globalStyles.opacityAnimation,
                globalStyles[state]
              )}
              style={{ height }}
            >
              {links.map((link, index) => {
                const { label } = link;

                return (
                  <div
                    key={`tourFooterLink-${index}`}
                    className={cx(
                      globalStyles.foreground,
                      globalStyles.col,
                      styles.buttonContainer
                    )}
                  >
                    <Button
                      light
                      onClick={handleButtonClick(link, props)}
                      containerClassName={styles.button}
                    >
                      {label}
                    </Button>
                  </div>
                );
              })}
            </div>

            <div
              className={cx(
                styles.continueContainer,
                tourStyles.continueContainer,
                globalStyles.opacityAnimation,
                globalStyles[state],
                isDesktop && tourStyles.isDesktop,
                isDesktop && styles.isDesktop
              )}
            >
              {isDesktop ? (
                <>
                  {isTablet ? (
                    <div
                      className={cx(
                        tourStyles.handContainer,
                        tourStyles.handAnimation,
                        tourStyles[state]
                      )}
                    >
                      <HandSvg alt="Hand" />
                    </div>
                  ) : (
                    <Lottie options={LOTTIE_OPTIONS} width={24} height={80} />
                  )}
                  <div className={tourStyles.continueText}>
                    CONTINUE EXPERIENCE
                  </div>
                </>
              ) : null}
            </div>

            <Dimmer
              visible={visible}
              className={cx(globalStyles.background, styles.dimmer)}
            />
          </>
        );
      }}
    </Transition>
  );
};

export default TourOutro;
